export default __webpack_public_path__ + "static/media/new-cta-link-disabled.4404c8b7.svg";